// extracted by mini-css-extract-plugin
module.exports = {"profile":"selfprofile_profile__1iXL-","entries":"selfprofile_entries__2P7oN","loader":"selfprofile_loader__2hcAK"};